<template>
  <div style="margin-top: 24px">
    <QS-h4-title title="可租车辆" />
    <QS-common-table
      :max-height="400"
      :data="tableData.statDept"
      :columns="columns"
      :pagination="false"
      :span-method="objectSpanMethod"
     />
  </div>
</template>
<script>
import mixin from '../../../mixins/vehicleProperty'

export default {
  mixins: [mixin],
  props: {
    tableData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      columns: [],
    }
  },
  watch: {
    tableData: {
      handler(val) {
        if (val.titles) this.columns = this.dealColumns(val.titles)
      },
      deep: true,
    },
  },
  methods: {
    // 列合并逻辑逻辑
    objectSpanMethod(params) {
      const { columnIndex } = params
      if (columnIndex === 0) {
        return this.cellMerge(this.tableData.statDept, params)
      }
    },
  },
}
</script>
